/**
 * Auto Form Method of Payment Wrapper
 * Wraps the shared MethodOfPayment component with auto-specific configuration
 */

import SharedMethodOfPayment from 'views/shared/MethodOfPayment/SharedMethodOfPayment';
import { AUTO_PAYMENT_OPTIONS } from 'views/shared/MethodOfPayment/configs';
import { SECTIONS } from 'views/auto_form/constants';
import {
  changeBilling,
  changeMethodOfPayment,
  updatePayments,
  changeAccountHolder,
  removeMissingMandatoryField,
  changeAgencyBilling,
} from 'reducers/autoPersonalFormReducer';
import useIsBinderDisabled from 'views/auto_form/hooks/useIsBinderDisabled';

// Auto-specific field components
import FormInput from 'components/fields/auto/FormInput';
import DateInput from 'components/fields/auto/DateInput';
import SelectInput from 'components/fields/auto/SelectInput';
import RadioInput from 'components/fields/auto/RadioInput';

const MethodOfPayment = () => {
  const isDisabled = useIsBinderDisabled();

  return (
    <SharedMethodOfPayment
      formStateKey="autoPersonalForm"
      sectionKey={SECTIONS.METHOD_OF_PAYMENT}
      paymentConfig={AUTO_PAYMENT_OPTIONS}
      isDisabled={isDisabled}
      actions={{
        changeBilling,
        changeMethodOfPayment,
        updatePayments,
        changeAccountHolder,
        removeMissingMandatoryField,
        changeAgencyBilling,
      }}
      components={{
        FormInput,
        DateInput,
        SelectInput,
        RadioInput,
      }}
    />
  );
};

export default MethodOfPayment;
